import { render, staticRenderFns } from "./projectTask.vue?vue&type=template&id=51ec0039"
import script from "./projectTask.vue?vue&type=script&lang=js"
export * from "./projectTask.vue?vue&type=script&lang=js"
import style0 from "./projectTask.vue?vue&type=style&index=0&id=51ec0039&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports